import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import SharedGPAto100 from "./SharedGPAto100";
import Shared100toGPA from "./Shared100toGPA";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
import GPAPlanner from "./SharedGPAPlanner";
const TITLE = "حساب المعدل التراكمي من 4 - حاسبة المعدل الجامعي";
const DESCRIPTION =
  "احسب المعدل التراكمي للمقررات الجامعية بسهولة من خلال حاسبة المعدل الجامعي. اعرف كيفية حساب المعدل التراكمي من 4 بسرعة ودقة.";
const KEYWORDS =
  "حساب المعدل التراكمي, حاسبة المعدل الجامعي, حساب المعدل من 4, حساب المعدل الجامعي";
const OG_URL = "https://do-calculate.com/calculator/ar/gpa4";
function GPA4() {
  const [courses, setCourses] = useState([
    { name: "رياضيات", credits: "3", grade: "A" },
    { name: "فيزياء", credits: "2", grade: "B+" },
    { name: "حاسوب", credits: "3", grade: "A-" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gpa, setGPA] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const [priorSemesterGPA, setPriorSemesterGPA] = useState(0);
  const [priorSemesterCreditsCompleted, setPriorSemesterCreditsCompleted] =
    useState(0);
  const gradeOptions = [
    "A+",
    "A",
    "A-",
    "B+",
    "B",
    "C+",
    "C",
    "D+",
    "D",
    "D-",
    "F",
  ];
  const addCourse = () => {
    setCourses([...courses, { name: "", credits: "", grade: "A+" }]);
  };
  const removeCourse = (index) => {
    const updatedCourses = [...courses];
    updatedCourses.splice(index, 1);
    setCourses(updatedCourses);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedCourses = [...courses];
    updatedCourses[index][name] = value;
    setCourses(updatedCourses);
  };
  const calculate = () => {
    setIsLoading(true);
    setError(null);
    let totalGradePoints = 0;
    let creditsSum = 0;
    for (const course of courses) {
      const credits = parseFloat(course.credits);
      const grade = course.grade;
      if (!isNaN(credits)) {
        const gradePoints = calculateGradePoints(grade);
        if (!isNaN(gradePoints)) {
          totalGradePoints += credits * gradePoints;
          creditsSum += credits;
        }
      }
    }
    if (creditsSum === 0) {
      setError("ادخل قيم صحيحة");
    } else {
      const calculatedGPA = totalGradePoints / creditsSum;
      setGPA(calculatedGPA.toFixed(2));
      setTotalCredits(creditsSum);
    }
    const priorSemesterGPAValue = parseFloat(priorSemesterGPA);
    const priorSemesterCreditsCompletedValue = parseFloat(
      priorSemesterCreditsCompleted
    );
    if (
      !isNaN(priorSemesterGPAValue) &&
      !isNaN(priorSemesterCreditsCompletedValue)
    ) {
      const cumulativeCredits = priorSemesterCreditsCompletedValue + creditsSum;
      const cumulativeGradePoints =
        priorSemesterGPAValue * priorSemesterCreditsCompletedValue +
        totalGradePoints;
      const cumulativeGPA = cumulativeGradePoints / cumulativeCredits;
      setGPA(cumulativeGPA.toFixed(2));
      setTotalCredits(cumulativeCredits);
    }
    setIsLoading(false);
  };
  const calculateGradePoints = (grade) => {
    let gradePoints;
    const gradeMap = {
      "A+": 4.0,
      A: 4.0,
      "A-": 3.7,
      "B+": 3.3,
      B: 3.0,
      "B-": 2.7,
      "C+": 2.3,
      C: 2.0,
      "C-": 1.7,
      "D+": 1.3,
      D: 1.0,
      "D-": 0.7,
      F: 0.0,
    };
    if (grade === "F") {
      gradePoints = 0;
    } else {
      gradePoints = gradeMap[grade] || NaN;
    }
    return gradePoints;
  };
  const calculateLetterGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "A+";
    } else if (gpa >= 3.7) {
      return "A";
    } else if (gpa >= 3.3) {
      return "A-";
    } else if (gpa >= 3.0) {
      return "B+";
    } else if (gpa >= 2.7) {
      return "B";
    } else if (gpa >= 2.3) {
      return "B-";
    } else if (gpa >= 2.0) {
      return "C+";
    } else if (gpa >= 1.7) {
      return "C";
    } else if (gpa >= 1.3) {
      return "C-";
    } else if (gpa >= 1.0) {
      return "D+";
    } else if (gpa >= 0.7) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateNumericalGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "97–100";
    } else if (gpa >= 3.7) {
      return "94–96";
    } else if (gpa >= 3.3) {
      return "90–93";
    } else if (gpa >= 3.0) {
      return "87–89";
    } else if (gpa >= 2.7) {
      return "84–86";
    } else if (gpa >= 2.3) {
      return "80–83";
    } else if (gpa >= 2.0) {
      return "77–79";
    } else if (gpa >= 1.7) {
      return "74–76";
    } else if (gpa >= 1.3) {
      return "67–69";
    } else if (gpa >= 1.0) {
      return "64–66";
    } else if (gpa >= 0.7) {
      return "60–63";
    } else {
      return "0–59";
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <p>
                  احسب المعدل التراكمي من 4 بسهولة باستخدام حاسبة المعدل الجامعي
                  المصممة لمساعدتك على معرفة نتيجتك بدقة وسرعة. تتيح لك هذه الأداة
                  إدخال المقررات الدراسية وعدد الساعات المعتمدة لكل مادة واختيار
                  التقدير المناسب، ثم تقوم بحساب المعدل التراكمي (GPA) تلقائيًا وفق
                  نظام 4.0 المعتمد في العديد من الجامعات.
                </p>

                <p>
                  سواء كنت ترغب في حساب معدل فصل دراسي واحد أو حساب المعدل التراكمي
                  الكلي بإضافة المعدل السابق وعدد الساعات المنجزة، يمكنك استخدام هذه
                  الحاسبة لمعرفة نتيجتك الحقيقية بدون أخطاء حسابية. كما يمكنك معرفة
                  التقدير الحرفي المقابل للمعدل مثل A أو B+ بالإضافة إلى النسبة
                  المئوية التقريبية المكافئة.
                </p>

                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    احسب المعدل التراكمي من 4{" "}
                  </h2>
                </div>
                <hr />
                <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                  المعدل التراكمي للفصل الدراسي السابق (اختياري):
                </div>
                <div
                  className="form-group"
                  style={{ display: "flex", marginBottom: "10px" }}
                >
                  <label htmlFor="priorGPA" style={{ width: "170px" }}>
                    المعدل التراكمي السابق
                  </label>
                  <input
                    type="number"
                    id="priorGPA"
                    value={priorSemesterGPA}
                    onChange={(e) => setPriorSemesterGPA(e.target.value)}
                    className="form-control"
                    style={{ width: "90%" }}
                  />
                </div>
                <div className="form-group" style={{ display: "flex" }}>
                  <label htmlFor="priorCredits" style={{ width: "170px" }}>
                    الساعات المكتملة
                  </label>
                  <input
                    type="number"
                    id="priorCredits"
                    value={priorSemesterCreditsCompleted}
                    onChange={(e) =>
                      setPriorSemesterCreditsCompleted(e.target.value)
                    }
                    className="form-control"
                    style={{ width: "90%" }}
                  />
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="course">المادة (اختياري)</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="credits">الساعات</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      {" "}
                      <label htmlFor="grade">العلامة</label>
                    </b>
                  </div>
                </div>
                {courses.map((course, index) => (
                  <div
                    key={index}
                    className="form-group d-flex align-items-center"
                    style={{ marginBottom: "10px" }}
                  >
                    <input
                      type="text"
                      name="name"
                      id="course"
                      placeholder="المادة"
                      value={course.name}
                      style={{ width: "100%" }}
                      className="form-control ml-2"
                      onChange={(e) => handleInputChange(index, e)}
                    />
                    <input
                      type="number"
                      name="credits"
                      id="credits"
                      placeholder="3"
                      value={course.credits}
                      className="form-control ml-2"
                      style={{ width: "100%" }}
                      onChange={(e) => handleInputChange(index, e)}
                    />
                    <select
                      name="grade"
                      id="grade"
                      value={course.grade}
                      className="form-control ml-2"
                      style={{ width: "100%" }}
                      onChange={(e) => handleInputChange(index, e)}
                    >
                      {gradeOptions.map((option, gradeIndex) => (
                        <option key={gradeIndex} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    <button
                      className="text-white btn bg-secondary"
                      style={{ marginRight: "2px" }}
                      onClick={() => removeCourse(index)}
                    >
                      حذف
                    </button>
                    <br />
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addCourse}
                >
                  إضافة مادة
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculate}
                  disabled={isLoading}
                >
                  احسب
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-7">
              <br />
              {error && (
                <div className="alert alert-warning">
                  <b>
                    <u> حدث خطأ :</u>
                  </b>{" "}
                  يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                </div>
              )}
              {gpa > 0 && (
                <div
                  style={{ fontSize: "19px" }}
                  className=" bg-light bg-gradient text-dark"
                >
                  <div className=" p-3   bg-success bg-gradient text-white">
                    <strong>النتائج</strong>
                  </div>
                  <div>
                    <table >
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td className="gpa-header">المعدل التراكمي</td>
                          <td>{gpa}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">الساعات الإجمالية</td>
                          <td>{totalCredits}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">التقدير</td>
                          <td>{calculateLetterGrade(gpa)}</td>
                        </tr>
                        <tr>
                          <td className="gpa-header">التقدير الرقمي</td>
                          <td> {calculateNumericalGrade(gpa)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <GPAPlanner />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPAto100 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <Shared100toGPA />
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية حساب التراكمي من 4{" "}
                    </h2>{" "}
                  </u>
                  <p>
                    لحساب معدل الأداء الأكاديمي الخاص بك، قم بقسمة إجمالي عدد
                    نقاط الدرجات التي حصلت عليها على إجمالي عدد وحدات الدراسات
                    ذات الدرجات الحروفية التي قمت بها. لكل وحدة دراسية، يتم كسب
                    الدرجات التالية:
                  </p>
                  <ul>
                    <li>A+ = 4</li>
                    <li>A = 4</li>
                    <li>A- = 3.7</li>
                    <li>B+ = 3.3</li>
                    <li>B = 3</li>
                    <li>B- = 2.7</li>
                    <li>C+ = 2.3</li>
                    <li>C = 2</li>
                    <li>C- = 1.7</li>
                    <li>D+ = 1.3</li>
                    <li>D = 1</li>
                    <li>D- = 0.7</li>
                    <li>F = 0</li>
                  </ul>
                  <p>
                    لحساب إجمالي نقاط الدرجات على سجلك الأكاديمي، قم بضرب نقاط
                    الدرجات لكل درجة حصلت عليها بعدد الوحدات في الدورة (استشر
                    دليل الكلية الخاص بك بشأن الدورات المكررة ودرجات الانقطاع).
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;
